import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, Observable, throwError } from 'rxjs';

import { AuthenticationService } from '../services/authentication.service';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {

  constructor(private authenticationService: AuthenticationService) { }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {

    return next.handle(request).pipe(catchError(err => {
      // Only handle authentication errors here
      if (err.status === 401) {
        // auto logout if 401 Unauthorized response returned from api
        this.authenticationService.logout();
      }

      // Let the error propagate to the service for proper handling
      return throwError(() => err);
    }));
  }
}
